<template>
  <div>
    <div class="container">
      <div class="row">
        <Info class="col-12"></Info>
        <PhotoSelector class="col-12"></PhotoSelector>
        <Search class="col-md-12"></Search>
        <UploadHistory class="col-12"></UploadHistory>
      </div>
    </div>
  </div>
</template>

<script>
import Info from "@/components/Info.vue";
import PhotoSelector from "@/components/PhotoSelector.vue";
import Search from "@/components/Search.vue";
import UploadHistory from "@/components/UploadHistory.vue";

export default {
  name: "App",
  components: {
    Info,
    PhotoSelector,
    Search,
    UploadHistory,
  },
};
</script>